import React, {useEffect} from "react";
import "./Dashboard.css";
import { Helmet } from "react-helmet";
import ActivitiesForm from "../components/ActivitiesForm";
import VisitorCounting from "../components/VisitorCounting";
import PopupPictureUpload from "../components/PopupPictureUpload";

function Dashboard() {
  return (
    <div>
      <Helmet>
        <title>Dashboard | Londonhouse </title>
      </Helmet>
      <h1>Dashboard</h1>
      <VisitorCounting />
      <ActivitiesForm />
      <PopupPictureUpload />
    </div>
  );
}
export default Dashboard;